import React, { useState } from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import auth from '../../lib/Auth'
import { Diagnostics } from './Diagnostics'
import { BetaFeatures } from './BetaFeatures'
import { DropdownItem } from '../DropdownItem'
import Dropdown from '../design-system/Dropdown'
import { UsersManagement } from './UsersManagement'
import { showHelp } from '../../lib/keyboardShortcutHelper'
import { useUserInfo } from '../../store/user'

export const UserMenu: React.FC = () => {
  const email = useUserInfo()?.email
  const [visible, setVisible] = useState<boolean>(false)

  return (
    <ArrowIconWrapper className="e2e-user-wrapper">
      <Dropdown
        onVisibleChange={(visible: boolean) => {
          setVisible(visible)
        }}
        visible={visible}
        trigger={['click']}
        overlay={() => (
          <>
            <UsersManagement />
            <BetaFeatures
              onClick={() => {
                setVisible(false)
              }}
            />
            <DropdownItem
              className="e2e-shortcuts"
              onClick={async () => {
                setVisible(false)
                await showHelp(email)
              }}
            >
              Keyboard shortcuts
            </DropdownItem>
            <Diagnostics setVisible={setVisible} />
            <DropdownItem
              className="e2e-logout"
              onClick={() => {
                setVisible(false)
                auth.logout()
              }}
            >
              Logout
            </DropdownItem>
          </>
        )}
      >
        <ArrowIcon />
      </Dropdown>
    </ArrowIconWrapper>
  )
}

const ArrowIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 19px; // To accomodate for scrollbar when visible
`

const ArrowIcon = styled(FontAwesomeIcon).attrs({
  size: '1x',
  icon: 'angle-down'
})`
  opacity: 0.5;
  color: #354052;
  cursor: pointer;
  font-size: 14px;
  padding: 12px 8px;

  &:hover {
    opacity: 1;
  }
`
